<template>
    <div
        :class="'board ' + direction"
        :style="{
            flexDirection: direction === 'horizontal' ? 'row' : 'column',
            height: height,
        }"
    >
        <div
            v-for="(node, idx) in loadedTree"
            :class="'node ' + (hasChildren(node) ? 'node-parent' : 'node-leaf')"
            :key="idx"
        >
            <button
                :class="'node-header ' + (active == node.id ? 'selected' : '')"
                @click.prevent.stop="$emit('select', node)"
            >
                <div>
                    <strong>{{ node.name }}</strong>
                </div>
                <div class="actions">
                    <slot name="actions" :node="node" />
                </div>
            </button>
            <template v-if="hasChildren(node)">
                <div class="node-body">
                    <div
                        v-for="(children, variant) in node.children"
                        class="board-variant"
                        :key="variant"
                    >
                        <slot name="variant" :node="node" :variant="variant">
                            <div class="variant-name">{{ variant }}</div>
                        </slot>
                        <board
                            :tree="children"
                            :height="'auto'"
                            direction="vertical"
                            :active="active"
                            @select="
                                (selection) => {
                                    $emit('select', selection);
                                }
                            "
                        >
                            <template #actions="{ node: childNode }">
                                <slot name="actions" :node="childNode" />
                            </template>
                            <template #variant="{ node, variant }">
                                <slot
                                    name="variant"
                                    :node="node"
                                    :variant="variant"
                                >
                                    <div class="variant-name">
                                        {{ variant }}
                                    </div>
                                </slot>
                            </template>
                        </board>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<style scoped lang="scss">
.board {
    display: flex;
    font-size: 12px;
    width: 100%;
    background: #eeee;
    border-radius: 10px;
    &.horizontal {
        width: 100%;
        overflow-x: scroll;
    }
    &.horizontal > .node {
        flex-basis: 240px;
        min-width: 240px;
        height: 100%;
        overflow-y: auto;
        padding: 10px;
        > .node-header {
            background: transparent;
            padding: 0;
            border: none;
            width: 100%;
            text-align: left;
            font-size: 14px;
            &.selected {
                background: var(--primary);
                color: #fff;
            }
        }
    }
    .node {
        padding: 20px;
        border: 1px solid #ddd;
        flex-grow: 1;
        &:first-child {
            border-radius: 10px 0 0 10px;
        }
        &:last-child {
            border-radius: 0 10px 10px 0;
        }
        .node-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .variant-name {
        margin-top: 10px;
        margin-bottom: 10px;
        color: #888;
    }
    ::v-deep {
        .board {
            border: none;
            .node {
                border: none;
                padding-left: 20px;
                padding-top: 0;
                padding-bottom: 0;
                padding-right: 0;

                .node-header {
                    background: #fff;
                    padding: 10px;
                    margin-bottom: 10px;
                    border: none;
                    border-radius: 3px;
                    width: 100%;
                    text-align: left;
                    &.selected {
                        background: var(--primary);
                        color: #fff;
                    }
                }
            }
        }
        .board-variant .board-variant {
            padding-left: 10px;
        }
        .board-variant > .board > .node {
            padding-left: 0px;
        }
    }
}
</style>
<script>
import keviApi from "../../keviApi";

export default {
    name: "board",
    props: {
        active: String,
        tree: {
            type: Array,
            required: false,
        },
        height: {
            type: String,
            default: "100vh",
        },
        direction: {
            type: String,
            default: "horizontal",
        },
    },
    data() {
        return {
            loadedTree: this.tree || [],
        };
    },
    mounted() {
        if (!this.tree) {
            this.loadTree();
        }
    },
    methods: {
        hasChildren(node) {
            return Object.values(node.children).length;
        },
        async loadTree() {
            let options = keviApi.getOptions("client-stages/tree", "GET");
            const responseTree = await this.$http(options);
            this.loadedTree = responseTree.data;
        },
        firstVariant(node) {
            return Object.keys(node.children)[0] || "";
        },
        multipleVariants(node) {
            return Object.keys(node.children).length > 1;
        },
    },
};
</script>
